import {computed, observable} from "mobx";
import {IndicadorService} from "../../../services";
import {getMensagemDeErro} from "../../../utils/functions";

export default class SolicitacaoNaoAtendidaFornecedorStore {
    @observable erro;
    @observable carregando;
    @observable dados;
    @observable razoes;

    constructor() {
        this.indicadorService = new IndicadorService();
    }

    filtrar = (filtro) => {
        this.carregando = true;
        this.erro = null;

        this.indicadorService.findSolicitacaoNaoAtendidaFornecedor(filtro).then(response => {
            const fornecedoresAgrupados = _.groupBy(response.data, (d) => d.fornecedor);
            const fornecedores = Object.keys(fornecedoresAgrupados);
            const razoesAgrupadas = _.groupBy(response.data, (d) => d.razaoDevolucao);
            const razoes = Object.keys(razoesAgrupadas);
        
            let dados = [];
            _.forEach(fornecedores, (fornecedor) => {
                let dado = { nome: fornecedor };
        
                const fornecedoresRazoes = fornecedoresAgrupados[fornecedor];
        
                _.forEach(fornecedoresRazoes, (fornecedorRazao) => {
                    dado = { ...dado, [fornecedorRazao.razaoDevolucao]: fornecedorRazao.quantidade };
                });
        
                dados = [ ...dados, dado ];
            });
        
            this.razoes = razoes;
            this.dados = dados;
            this.carregando = false;
        }).catch(error => {
            this.erro = getMensagemDeErro(error);
            this.carregando = false;
        });

        this.carregando = false;
    }
}
